import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

export const userSchema = addKeyToFieldsRecursively(
  yup.object({
    userId: yup.string().required(),
    customerId: yup.string().required(),
    loginId: yup.string().required(),
    firstName: yup.string(),
    lastName: yup.string(),
    primaryEmail: yup.string().email(),
    status: yup.string(),
    // TODO: add more fields as needed
  })
);
